import React from 'react';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import Button from 'v3/components/Button';
import Modal from 'v3/components/Modal';
import Text from 'v3/components/Text';

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  setFrontImageCnh,
  data
}) {

  const handleClose = () => {
    setFrontImageCnh([]);
    onClose();
  }
  return (
    <Modal
      show={isOpen}
      handleClose={handleClose}
      heading={
        <Text color="dark" type="header" weight="500">
          Atualizar Motorista
        </Text>
      }
      body={
        data?.cnhDispatchDate ? (
          <Text color="dark" type="header" fontSize="15px" weight="300">
            Este motorista possui CNH cadastrada com data de emissão em {moment(data.cnhDispatchDate,
              'YYYY-MM-DD').format('DD/MM/YYYY')}. Deseja atualizar os dados existentes?
          </Text>
        ) : (
          <Text color="dark" type="header" fontSize="15px" weight="300">
            Este motorista já possui dados cadastrados. Deseja continuar com a atualização?
          </Text>
        )
      }
      footer={
        <Row>
          <Col>
            <Button variant="secondary" onClick={handleClose}>
              <Text type="regular" weight="600">
                Cancelar
              </Text>
            </Button>
          </Col>
          <Col>
            <Button variant="success" onClick={onConfirm}>
              <Text type="regular" weight="600">
                Prosseguir
              </Text>
            </Button>
          </Col>
        </Row>
      }
    />
  );
}
